import Button from "../../../../components/button";
import { ReactComponent as EyeIcon } from "../../../../images/eye.svg";
import { ReactComponent as UploadIcon } from "../../../../images/upload.svg";

import { CommercialODApplicationDocsEnum } from "../../../../models";

interface CommercialODApplicationDocumentListProps {
  documents: {
    name: CommercialODApplicationDocsEnum;
    previewDocument: (fileName: string) => void;
    uploadDocument: (docName: string) => void;
  }[];
  isDocPreviewing: {
    [docName: string]: boolean;
  };
}

export default function CommercialODApplicationDocumentList({
  documents,
  isDocPreviewing,
}: CommercialODApplicationDocumentListProps) {
  return (
    <div>
      {documents.map((document) => {
        const { name, previewDocument, uploadDocument } = document;
        return (
          <div key={document.name}>
            <div className="d-flex align-items-center justify-content-between">
              <p className="w-50">{name}</p>
              <div className="d-flex align-items-center justify-content-center">
                <Button
                  style={{ marginRight: "30px" }}
                  loading={isDocPreviewing[document.name] || false}
                  variant="blue"
                  title="Preview Document"
                  onClick={() => previewDocument(name)}
                  iconOnly
                >
                  <EyeIcon />
                </Button>
                {/* RBI AUDIT: Document must be previewed in-portal instead of
                    downloaded to the user's device. Original download button is
                    commented out below (not removed) for audit trail.
                <Button
                  style={{ marginRight: "30px" }}
                  loading={isDocDownloading[document.name] || false}
                  variant="blue"
                  onClick={() => downloadDocument(name)}
                  iconOnly
                >
                  <DownloadIcon />
                </Button>
                */}
                <Button
                  variant="blue"
                  onClick={() => uploadDocument(name)}
                  iconOnly
                >
                  <UploadIcon />
                </Button>
              </div>
            </div>
            <hr />
          </div>
        );
      })}
    </div>
  );
}
